import React from 'react';

import './Error.css';
import { Link } from 'react-router-dom';

const Error = () => (

  <section className="Error h-screen w-screen">
    <h1></h1>
    <h1 className="font-bold text-4xl text-center">Błąd aplikacji</h1>
    <p className="text-3xl text-center">Prosimy zanotować kroki, które doprowadziły do tej sytuacji<br/> i zgłosić je na adres: <a href= "mailto:kontakt@jemwszkole.pl">kontakt@jemwszkole.pl</a></p>
    <p className="text-3xl text-center mt-6">
    <Link to="/login" className="mt-6">
      <p className="text-3xl inline underline font-bold">Wróć do strony logowania</p>
    </Link>
    </p>

  </section>
);

export default Error;
